export const QUEUE_STATUS = {
     SOLVING: 'SOLVING',
     SOLVED: 'SOLVED',
};
